/* cart-drawer-amatora.js
   JS del carrito lateral de Tres Cuartos. El HTML y la documentación viven en
   sections/cart-drawer-amatora.liquid; se carga con defer desde ahí. */
(() => {
  if (window.AmatoraCart) return;

  const root = document.getElementById('am-cart-drawer');
  if (!root) return;
  const DRAWER_SECTION = 'cart-drawer-amatora';
  const SOURCE_ID = 'amatora-cart';
  const rootUrl = (root.dataset.rootUrl || '/').replace(/\/$/, '');
  const changeUrl = root.dataset.changeUrl || '/cart/change';
  const updateUrl = root.dataset.updateUrl || '/cart/update';
  const RECO_URL = root.dataset.recoUrl || '/recommendations/products';
  const panel = root.querySelector('.cart-am__panel');
  let lastFocus = null;
  let busy = false;

  /* ---------- Contador (burbuja de Horizon + [data-am-cart-count]) ---------- */
  const updateCounters = (count, notify) => {
    document.querySelectorAll('[data-am-cart-count]').forEach((el) => {
      el.textContent = count;
      el.toggleAttribute('hidden', !(count > 0));
    });
    if (notify) {
      // cart-icon de Horizon escucha 'cart:update' y lee detail.data.itemCount
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: null, sourceId: SOURCE_ID, data: { itemCount: count, source: SOURCE_ID } }
      }));
    }
  };

  const initSliders = (scope) => {
    if (window.SliderAmatora && typeof window.SliderAmatora.initAll === 'function') {
      window.SliderAmatora.initAll(scope);
    }
  };

  /* ---------- Sugeridos ---------- */
  const shuffle = (arr) => {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  };

  const loadUpsell = async (scope) => {
    const box = scope && scope.querySelector('[data-am-upsell]');
    if (!box || !box.dataset.productId) return;
    const key = box.dataset.productId + ':' + (box.dataset.intent || '') + ':' + (box.dataset.limit || '');
    if (box.dataset.amUpsellKey === key) return;
    box.dataset.amUpsellKey = key;
    try {
      const url = RECO_URL
        + '?section_id=cart-upsell-amatora'
        + '&product_id=' + encodeURIComponent(box.dataset.productId)
        + '&limit=' + encodeURIComponent(box.dataset.limit || '8')
        + '&intent=' + encodeURIComponent(box.dataset.intent || 'related');
      const res = await fetch(url);
      if (!res.ok) return;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = doc.querySelector('[data-am-upsell-track]');
      if (!fresh || !fresh.children.length) return;
      shuffle(Array.from(fresh.children)).forEach((slide) => fresh.appendChild(slide));
      const current = box.querySelector('[data-am-upsell-track]');
      if (current) {
        const inst = window.SliderAmatora && window.SliderAmatora.get ? window.SliderAmatora.get(current) : null;
        if (inst && inst.destroy) inst.destroy();
        current.replaceWith(fresh);
      } else {
        box.appendChild(fresh);
      }
      box.hidden = false;
      initSliders(box);
    } catch (err) {
      console.warn('[cart-upsell-amatora]', err);
    }
  };

  /* ---------- Validador de código postal ---------- */
  const ZIP_KEY = 'am-cart-zip';
  const zipLists = { cdmx: null, gdl: null };
  const zipUrls = { cdmx: root.dataset.zipCdmx, gdl: root.dataset.zipGdl };
  const WHATSAPP = root.dataset.whatsapp || '';

  const storedZip = () => { try { return sessionStorage.getItem(ZIP_KEY) || ''; } catch (e) { return ''; } };
  const storeZip = (code) => { try { sessionStorage.setItem(ZIP_KEY, code); } catch (e) {} };

  const loadZips = async (zone) => {
    if (zipLists[zone]) return zipLists[zone];
    const res = await fetch(zipUrls[zone]);
    const data = await res.json();
    zipLists[zone] = new Set((data.valid_codes || []).map((c) => String(c).trim()));
    return zipLists[zone];
  };

  // Misma regla de negocio que el validador anterior del carrito:
  // gdl-cdmx = ambas ciudades; cdmx / gdl = solo esa ciudad; mezclar exclusivos = conflicto.
  const analyze = (scope) => {
    const out = { cdmx: [], gdl: [], both: [], items: [] };
    scope.querySelectorAll('.cart-am__item[data-zone]').forEach((el) => {
      const title = el.dataset.title || '';
      out.items.push(title + ' x' + (el.dataset.qty || '1'));
      if (out[el.dataset.zone]) out[el.dataset.zone].push(title);
    });
    if (out.cdmx.length && out.gdl.length) out.zone = 'conflict';
    else if (out.cdmx.length) { out.zone = 'cdmx'; out.check = ['cdmx']; }
    else if (out.gdl.length) { out.zone = 'gdl'; out.check = ['gdl']; }
    else if (out.both.length) { out.zone = 'both'; out.check = ['cdmx', 'gdl']; }
    else { out.zone = 'none'; out.check = []; }
    return out;
  };

  const cityFor = (code) => {
    if (code >= '01000' && code <= '16999') return 'Ciudad de México';
    if (code >= '44000' && code <= '45999') return 'Guadalajara';
    return '';
  };

  const setCheckout = (scope, state, code, info) => {
    const btn = scope.querySelector('[data-am-checkout]');
    const wa = scope.querySelector('[data-am-whatsapp]');
    const ok = state === 'ok';
    if (btn) {
      btn.disabled = !ok;
      btn.setAttribute('aria-disabled', String(!ok));
      btn.hidden = state === 'invalid' && !!wa;
    }
    if (wa) {
      wa.hidden = state !== 'invalid';
      if (state === 'invalid' && WHATSAPP) {
        const msg = 'Hola, quiero cotizar envío al CP ' + code + ':\n\n'
          + (info.items || []).map((i) => '• ' + i).join('\n') + '\n\n¿Hacen envíos a mi zona?';
        wa.href = 'https://wa.me/' + WHATSAPP + '?text=' + encodeURIComponent(msg);
      }
    }
  };

  const feedback = (scope, status, html) => {
    const fb = scope.querySelector('[data-am-zip-feedback]');
    if (!fb) return;
    fb.hidden = !html;
    fb.dataset.status = status || '';
    fb.innerHTML = html || '';
  };

  // Validado: el bloque se compacta a una línea con "Cambiar"
  const setZipOk = (scope, text) => {
    const box = scope && scope.querySelector('[data-am-zip]');
    if (!box) return;
    box.classList.toggle('is-ok', !!text);
    const summary = box.querySelector('[data-am-zip-summary]');
    if (summary) summary.textContent = text || '';
  };

  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const list = (arr) => '<ul>' + arr.map((t) => '<li>' + esc(t) + '</li>').join('') + '</ul>';

  const validateZip = async (scope, rawCode, silent) => {
    if (!scope || !scope.querySelector('[data-am-zip]')) return;
    const code = String(rawCode || '').trim();
    const input = scope.querySelector('[data-am-zip-input]');
    if (input && input.value !== code) input.value = code;
    setZipOk(scope, '');
    setCheckout(scope, 'pending');
    if (!code) { feedback(scope); return; }
    if (!/^\d{5}$/.test(code)) {
      if (!silent) feedback(scope, 'error', 'Escribe un código postal de 5 dígitos.');
      return;
    }
    const info = analyze(scope);
    if (info.zone === 'conflict') {
      feedback(scope, 'error',
        '<strong>No podemos enviar en un mismo pedido productos de ciudades distintas.</strong>'
        + '<p class="m-0-amatora mt-2-amatora">Solo CDMX:</p>' + list(info.cdmx)
        + '<p class="m-0-amatora mt-2-amatora">Solo Guadalajara:</p>' + list(info.gdl));
      setCheckout(scope, 'invalid', code, info);
      return;
    }
    feedback(scope, '', 'Verificando…');
    try {
      const sets = await Promise.all(info.check.map(loadZips));
      const valid = sets.some((set) => set.has(code));
      if (!valid) {
        let why = 'Por ahora no tenemos envío a ese código postal.';
        if (info.zone === 'cdmx') why = 'Tu carrito solo se puede enviar a CDMX.';
        if (info.zone === 'gdl') why = 'Tu carrito solo se puede enviar a Guadalajara.';
        feedback(scope, 'error', '<strong>' + why + '</strong>'
          + (WHATSAPP ? '<p class="m-0-amatora mt-1-amatora">Escríbenos y cotizamos tu envío.</p>' : ''));
        setCheckout(scope, 'invalid', code, info);
        return;
      }
      storeZip(code);
      const city = info.zone === 'cdmx' ? 'Ciudad de México' : info.zone === 'gdl' ? 'Guadalajara' : cityFor(code);
      feedback(scope);
      setZipOk(scope, 'Enviamos a tu zona' + (city ? ' en ' + city : '') + ' · CP ' + code);
      setCheckout(scope, 'ok', code, info);
    } catch (err) {
      console.warn('[cart-zip]', err);
      feedback(scope, 'error', 'No pudimos verificar. Intenta de nuevo.');
      setCheckout(scope, 'pending');
    }
  };

  const validateAll = () => {
    const code = storedZip();
    document.querySelectorAll('[data-am-cart-scope]').forEach((scope) => validateZip(scope, code, true));
  };

  /* ---------- Section Rendering ---------- */
  const fetchSection = async (sectionId) => {
    const res = await fetch(rootUrl + '/?sections=' + sectionId, { headers: { 'Accept': 'application/json' } });
    const json = await res.json();
    return json[sectionId] || '';
  };

  const swapInner = (scope, html) => {
    if (!html) return null;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('.cart-am__inner');
    const current = scope.querySelector('.cart-am__inner');
    if (!fresh || !current) return null;
    current.replaceWith(fresh);
    initSliders(scope);
    return parseInt(fresh.dataset.count || '0', 10);
  };

  const api = {
    isOpen() { return root.classList.contains('is-open'); },
    open() {
      if (api.isOpen()) return;
      lastFocus = document.activeElement;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('am-cart-lock');
      requestAnimationFrame(() => {
        const closeBtn = root.querySelector('.cart-am__close');
        (closeBtn || panel).focus({ preventScroll: true });
        initSliders(root);
        loadUpsell(root);
      });
      document.dispatchEvent(new CustomEvent('amatora:cart:open'));
    },
    close() {
      if (!api.isOpen()) return;
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('am-cart-lock');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
      document.dispatchEvent(new CustomEvent('amatora:cart:close'));
    },
    toggle() { api.isOpen() ? api.close() : api.open(); },
    async refresh() {
      const count = swapInner(root, await fetchSection(DRAWER_SECTION));
      const page = document.querySelector('[data-am-cart-scope="page"]');
      if (page && page.dataset.sectionId) swapInner(page, await fetchSection(page.dataset.sectionId));
      if (count !== null) updateCounters(count, true);
      document.querySelectorAll('[data-am-cart-scope]').forEach((scope) => {
        if (scope === root && !api.isOpen()) return;
        loadUpsell(scope);
      });
      validateAll();
      document.dispatchEvent(new CustomEvent('amatora:cart:refreshed'));
    },
    async change(line, quantity) {
      if (busy) return;
      busy = true;
      document.querySelectorAll('[data-am-cart-scope]').forEach((s) => s.classList.add('is-busy'));
      try {
        const res = await fetch(changeUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line, quantity })
        });
        if (!res.ok) throw new Error('cart/change ' + res.status);
        await api.refresh();
      } catch (err) {
        console.warn('[cart-drawer-amatora]', err);
      } finally {
        busy = false;
        document.querySelectorAll('[data-am-cart-scope]').forEach((s) => s.classList.remove('is-busy'));
      }
    }
  };
  window.AmatoraCart = api;

  /* ---------- Nota del pedido: se guarda al dejar de escribir ---------- */
  let noteTimer = null;
  const saveNote = (value) => fetch(updateUrl + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ note: value })
  }).catch((err) => console.warn('[cart-note]', err));

  document.addEventListener('input', (e) => {
    const t = e.target;
    if (!(t instanceof HTMLTextAreaElement) || !t.matches('[data-am-note]')) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(() => saveNote(t.value), 600);
  });

  /* ---------- Agregar al carrito ---------- */
  const openAfterAdd = () => {
    const cfg = window.AmatoraConfig || {};
    return cfg.cartOpenDrawer !== false;
  };

  document.addEventListener('amatora:cart:added', async () => {
    await api.refresh();
    if (openAfterAdd()) api.open();
  });

  // Formularios nativos de Horizon (quick add, product form…) disparan cart:update
  document.addEventListener('cart:update', async (e) => {
    const d = (e && e.detail) || {};
    if (d.sourceId === SOURCE_ID || (d.data && d.data.didError)) return;
    await api.refresh();
    if (d.data && d.data.source === 'product-form-component' && openAfterAdd()) api.open();
  });

  /* ---------- Clicks y teclado ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target;
    if (!(t instanceof Element)) return;

    const openBtn = t.closest('[data-am-cart-open]');
    if (openBtn) { e.preventDefault(); api.open(); return; }

    const closeBtn = t.closest('[data-am-cart-close]');
    if (closeBtn && root.contains(closeBtn)) {
      if (closeBtn.tagName !== 'A') e.preventDefault();
      api.close();
      return;
    }

    const scope = t.closest('[data-am-cart-scope]');
    if (!scope) return;

    const zipBtn = t.closest('[data-am-zip-check]');
    if (zipBtn) {
      e.preventDefault();
      const input = scope.querySelector('[data-am-zip-input]');
      validateZip(scope, input ? input.value : '', false);
      return;
    }

    const zipEdit = t.closest('[data-am-zip-edit]');
    if (zipEdit) {
      e.preventDefault();
      setZipOk(scope, '');
      const input = scope.querySelector('[data-am-zip-input]');
      if (input) { input.focus(); input.select(); }
      return;
    }

    const qtyBtn = t.closest('[data-am-qty]');
    if (qtyBtn) {
      e.preventDefault();
      api.change(parseInt(qtyBtn.dataset.line, 10), Math.max(0, parseInt(qtyBtn.dataset.amQty, 10)));
      return;
    }
    const removeBtn = t.closest('[data-am-remove]');
    if (removeBtn) {
      e.preventDefault();
      api.change(parseInt(removeBtn.dataset.line, 10), 0);
    }
  });

  document.addEventListener('keydown', (e) => {
    const t = e.target;
    if (e.key === 'Enter' && t instanceof HTMLInputElement && t.matches('[data-am-zip-input]')) {
      e.preventDefault();
      validateZip(t.closest('[data-am-cart-scope]'), t.value, false);
      return;
    }
    if (e.key === 'Escape' && api.isOpen()) api.close();
  });

  // Solo dígitos en el CP; al cambiarlo se vuelve a bloquear el pago hasta verificar
  document.addEventListener('input', (e) => {
    const t = e.target;
    if (!(t instanceof HTMLInputElement) || !t.matches('[data-am-zip-input]')) return;
    t.value = t.value.replace(/\D/g, '').slice(0, 5);
    const scope = t.closest('[data-am-cart-scope]');
    setCheckout(scope, 'pending');
    feedback(scope);
    if (t.value.length === 5) validateZip(scope, t.value, false);
  });

  // Nunca se va al checkout sin CP válido (aunque alguien quite el disabled)
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-am-checkout-form]')) return;
    const btn = form.querySelector('[data-am-checkout]');
    if (btn && btn.disabled) {
      e.preventDefault();
      const scope = form.closest('[data-am-cart-scope]');
      const input = scope && scope.querySelector('[data-am-zip-input]');
      if (input) input.focus();
      feedback(scope, 'error', 'Verifica tu código postal para continuar.');
    }
  });

  // Focus trap
  root.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab' || !api.isOpen()) return;
    const focusables = panel.querySelectorAll('a[href]:not([hidden]), button:not([disabled]):not([hidden]), input, select, textarea, summary, [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    const first = focusables[0], last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- Arranque ---------- */
  const inner = root.querySelector('.cart-am__inner');
  updateCounters(parseInt((inner && inner.dataset.count) || '0', 10), false);
  document.querySelectorAll('[data-am-cart-scope="page"]').forEach((scope) => loadUpsell(scope));
  validateAll();

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:select', (e) => {
      if (e.detail && e.detail.sectionId === DRAWER_SECTION) api.open();
    });
    document.addEventListener('shopify:section:deselect', (e) => {
      if (e.detail && e.detail.sectionId === DRAWER_SECTION) api.close();
    });
  }
})();
